import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 100px;
`

const Distancer = styled.div`
    height: 100px;
    width: 5px;
`


const OrangeLine = () => {
    return (
        <div>
        <Distancer/>
        <Wrapper>
            <svg width="825" height="3" viewBox="0 0 825 3" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="3" width="3" height="825" transform="rotate(-90 0 3)" fill="#FF4C00"/>
            </svg>
        </Wrapper>
        </div>
    )
}

export default OrangeLine
